/**
 * CPG vehicle bar (P1 chrome rebuild) — behavior for snippets/cpg-vehicle-bar.liquid.
 * Reflects the active vehicle (window.CPGFitment + 'cpg:vehicle-changed'): white
 * "no vehicle" state vs mint "shopping for <vehicle>" state, fills the label and
 * the "N fit" pill (total fitting parts, fetched once per vehicle from the catalog
 * API and cached), and wires Remove. Add/Switch are the [data-cpg-garage-button]s,
 * already handled by the YMM widget.
 */
(function () {
  'use strict';

  var API_BASE_FALLBACK = 'https://carpartglobal-api-743237931312.us-central1.run.app/storefront/fitment';

  function apiBase() {
    var host = document.querySelector('[data-cpg-ymm-widget][data-cpg-api-base]');
    return (host && host.getAttribute('data-cpg-api-base')) || API_BASE_FALLBACK;
  }
  // /category-counts lives under .../fitment; the catalog browse lives under .../catalog.
  function catalogBase() { return apiBase().replace(/\/fitment$/, '/catalog'); }

  function readVehicle() {
    try {
      if (window.CPGFitment && CPGFitment.getVehicle) return CPGFitment.getVehicle();
      var raw = localStorage.getItem('cpg:garage:vehicle');
      var v = raw ? JSON.parse(raw) : null;
      return v && v.year && v.make && v.model ? v : null;
    } catch (e) { return null; }
  }
  function vehicleText(v) {
    return [v.year, v.make, v.model, v.submodel].filter(Boolean).join(' ');
  }
  function fmt(n) { try { return Number(n).toLocaleString('en-US'); } catch (e) { return String(n); } }

  function init(bar) {
    if (bar.__cpgVbarInit) return; bar.__cpgVbarInit = true;
    var labelEl = bar.querySelector('[data-cpg-vbar-label]');
    var pillEl = bar.querySelector('[data-cpg-vbar-pill]');
    var removeBtn = bar.querySelector('[data-cpg-vbar-remove]');
    var lastKey = null;

    // comma-format the server-rendered catalog total ("showing all 43,518 parts")
    var totalEl = bar.querySelector('[data-cpg-vbar-total]');
    if (totalEl) { var rawTotal = (totalEl.textContent || '').replace(/[^0-9]/g, ''); if (rawTotal) totalEl.textContent = fmt(rawTotal); }

    function paint() {
      var v = readVehicle();
      document.documentElement.classList.toggle('cpg-has-vehicle', !!v);
      if (!v) { if (pillEl) { pillEl.hidden = true; pillEl.textContent = ''; } lastKey = null; return; }
      if (labelEl) labelEl.textContent = vehicleText(v);
      var key = [v.year, v.make, v.model].join('|');
      if (key === lastKey) return;
      lastKey = key;
      fetchCount(v, key);
    }

    function fetchCount(v, key) {
      var cacheKey = 'cpg:vbar:count:' + key;
      try { var c = sessionStorage.getItem(cacheKey); if (c != null) { showPill(c); return; } } catch (e) {}
      var qs = 'year=' + encodeURIComponent(v.year) + '&make=' + encodeURIComponent(v.make) +
        '&model=' + encodeURIComponent(v.model) + '&page_size=1';
      fetch(catalogBase() + '/products?' + qs)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          var total = d.total != null ? d.total : (d.total_count != null ? d.total_count :
            (d.pagination && d.pagination.total != null ? d.pagination.total : null));
          if (total == null) return;
          try { sessionStorage.setItem(cacheKey, String(total)); } catch (e) {}
          showPill(total);
        })
        .catch(function () {});
    }
    function showPill(total) {
      if (!pillEl) return;
      pillEl.textContent = fmt(total) + (Number(total) === 1 ? ' part fits' : ' parts fit');
      pillEl.hidden = false;
    }

    if (removeBtn) removeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      try { if (window.CPGFitment && CPGFitment.clearVehicle) CPGFitment.clearVehicle(); } catch (err) {}
    });

    window.addEventListener('cpg:vehicle-changed', paint);
    window.addEventListener('storage', function (e) { if (e.key === 'cpg:garage:vehicle') { lastKey = null; paint(); } });
    window.addEventListener('pageshow', paint);
    paint();
  }

  function boot() { var bar = document.querySelector('[data-cpg-vbar]'); if (bar) init(bar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
